import React, { Fragment } from "react";
import DataGrid from "../../../dataGrid";
import GridConfig from "./ProHistoryGridConfig";
import { withStyles, Button } from "@material-ui/core";
import styles from "../../Settings/styles";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import formatDate from "date-fns/format";
import { getUTCDate } from "../../../dataGrid/gridUtilities";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../appMessages";
import { AppLoading } from "../../../../loaders/loaders";

class ProHistoryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      planDate: null,
      terminalCode: null,
      gridData: [],
      searchedPro: "",
      loading: false
    };
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateSearchText = event => {
    this.setState({
      searchedPro: event.target.value
    });
  };

  resetData = () => {
    this.setState({
      planDate: null,
      terminalCode: null,
      gridData: [],
      loading: false
    });
  };

  fetchProHistory = () => {
    const { searchedPro } = this.state;

    this.setState({
      loading: true
    });
    
    if (searchedPro) {
      getDataWithQueryString("GetProHistory", `proId=${searchedPro}`).then(
        response => {
          if (response.status === 200) {
            this.setState({
              planDate: response.data.planDate,
              terminalCode: response.data.terminalCode,
              gridData: response.data.proVersions ?? [],
              loading: false
            });
          } else {
            this.resetData();
          }
        },
        error => {
          this.resetData();
        }
      );
    } else {
      this.resetData();
      this.props.enqueueSnackbar(MESSAGES.PRO_HISTORY.EMPTY_PROID_SEARCH, {
        variant: "error"
      });
    }
  };

  render() {
    const { config } = this.gridConfig;
    const { classes } = this.props;
    return (
      <Fragment>
        <header
          className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}
        >
          <span>Pro History</span>
        </header>
        <div
          className={`${classes.gridContainer} ${classes.proHistoryGridContainer}`}
        >
          <div className={`${classes.gridHead}`}>
            <div style={{ width: 200 }} className={classes.searchContainer}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search"
                autoFocus
                classes={{
                  root: classes.searchInputRoot,
                  input: classes.searchInput
                }}
                onChange={this.updateSearchText}
                value={this.state.quickFilterText}
              />
            </div>
            <span>
              <Button
                variant="contained"
                size="small"
                color="primary"
                classes={{ root: classes.buttonRoot }}
                onClick={this.fetchProHistory}
                data-automationid="search"
              >
                Search
              </Button>
            </span>

            <div className={classes.terminalInfo}>
              <p>
                <span className={classes.bold}>Plan Date: </span>
                {this.state.planDate
                  ? formatDate(getUTCDate(this.state.planDate), "MM/dd/yyyy")
                  : this.state.planDate}
              </p>
              <p>
                <span className={classes.bold}>Terminal: </span>
                {this.state.terminalCode}
              </p>
            </div>
          </div>

          <div className={`${classes.dataGrid} ${classes.proHistoryGrid}`}>
            {this.state.loading ? (
              <AppLoading />
            ) : (
              <DataGrid
                defaultColDef={config.defaultColDef}
                columnDefs={config.columns}
                config={config}
                rowData={this.state.gridData}
                enableSorting={config.enableSorting}
                onGridReady={this.onGridReady}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(ProHistoryGrid);
